import type { Message } from '@patsnap/tahiti-core/common/message';

/**
 * Patsnap Copilot 套餐种类
 */
export enum CopilotPlan {
    A = 'A',
    B = 'B'
}

/**
 * Patsnap Copilot 当前用量
 */
export interface PatsnapCopilotUsage {
    /**
     * 是否启用
     */
    enabled: boolean;
    /**
     * 当前用量
     */
    currentAmount: number;
    /**
     * 最大用量
     */
    maxAmount: number;
    /**
     * 是否启用升级邀请
     */
    upgradeInvite: boolean;
    /**
     * 套餐种类
     */
    plan: CopilotPlan;
}

export interface SuggestionParams {
    fields: string;
    keyword: string;
    n: number;
}

export enum ESectionType {
    BENEFIT = 'BENEFIT',
    COMPANY = 'COMPANY',
    AUTOCOMPLETE = 'AUTOCOMPLETE'
}

type ACTION_CALLBACK_TYPE = 'JUMP_TO_SOURCE';

interface ISuggestionItem {
    section: ESectionType;
    content: { value: string }[]
}

export interface ExternalRenderer {
    render: (data: { turn: CopilotMessageTurn }) => Promise<HTMLElement>;
    dispose: () => void;
}

export interface CopilotMessageContext<T = any> {
    params: T;
    replyTs: number;
    source: string;
}

export interface WelComeMessage {
    title?: string;
    prompt: string;
    intent: string;
}

export const PatsnapCopilotService = Symbol('PatsnapCopilotService');

export interface PatsnapCopilotService {
    /**
     * 反馈
     * @param data
     * @returns
     */
    feedback: (data: {
        module: string;
        page_params: string;
        type: 'LIKE' | 'DISLIKE';
        query: string;
        question: string;
        answer: string;
        intent: string;
        product?: string;
    }) => Promise<void>;
    /**
     * 历史记录标识符
     * @description 用于标识历史记录的所属
     */
    historyIdentifier: () => string;
    rendererFactory: (intent: string) => { new (): ExternalRenderer } | undefined;
    patsnapCopilotUsage: PatsnapCopilotUsage;
    toast: Message;
    pageParamFunc: () => any;
    /**
     * 返回 false 时，不渲染可交互的状态
     */
    actionCallback: (type: ACTION_CALLBACK_TYPE, data: Record<string, unknown>) => void | boolean;
    /**
     * 用于校验消息记录上下文
     * @param context
     * @returns
     */
    contextValidator: <T = any>(context: CopilotMessageContext<T>) => boolean;
    source: string;
    getCurrentLanguage: () => string;
    getSocketPath: () => Promise<string> | string;
    welcomeMessages?: () => Promise<WelComeMessage[]>;
    getSuggestion: (data: SuggestionParams) => Promise<ISuggestionItem[]>;
    generateViewHref?: (context: { patentId: string; }) => string | void;
    generateCompanyHref?: (context: { id: string; }) => string | void;
    /**
     * for intent: PATENT_LIST
     * @param htmlString
     * @returns
     */
    getInnerText?: (htmlString: string) => string;
    /**
     * 仅当 PatsnapCopilotUsage.upgradeInvite 为 true 时有效
     * @returns
     */
    getInvitationService?: () => Promise<{ init: (entry: string, error: Error | null) => void }>;
}

export interface CopilotMessageTurn {
    context: {
        params: unknown;
        replyTs: number;
        source: string;
    }
}
